var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('fancy-image-uploader',{attrs:{"conversion":_vm.imageType},on:{"select-image":_vm.imageUploaded},scopedSlots:_vm._u([{key:"default",fn:function({ launch }){return [_c('button',{staticClass:"menu-button",on:{"click":launch}},[_c('app-icon',{staticClass:"h-5 w-5",attrs:{"name":"image-add-circle-stroke"}})],1)]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }